<template>
  <div v-if="totalPages > 1" class="app-pagination">
    <button class="app-pagination__control prev" :disabled="!currentPage" @click="ChangePage(-1)">
      <span class="material-icons-outlined">navigate_before</span>
      {{ 'Previous' | t }}
    </button>
    <span class="app-pagination__control label">
      Page <mark>{{ currentPage + 1 }}</mark> of {{ totalPages }}
    </span>
    <button
      class="app-pagination__control next"
      :disabled="currentPage === totalPages - 1"
      @click="ChangePage(1)"
    >
      {{ 'Next' | t }}
      <span class="material-icons-outlined">navigate_next</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    totalPages: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 0
    }
  },
  methods: {
    ChangePage(val) {
      this.currentPage += val
      const scrollTo =
        (
          document.getElementById('spookynook-activenet-calendar-widget') ||
          document.getElementById('spookynook-activenet-schedules-widget')
        ).getBoundingClientRect().top +
        window.scrollY -
        100
      window.scrollTo({ top: scrollTo, behavior: 'smooth' })

      this.$emit('page-change', this.currentPage)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-pagination {
  height: 40px;
  background: $color-gray-dark;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @include media-breakpoint-up(lg) {
    padding: 0 20px;
  }

  &__control {
    border: 0;
    background: transparent;
    box-shadow: none;
    font-size: rem(14);
    line-height: rem(19);
    font-weight: bold;
    color: $color-white;
    cursor: pointer;
    display: flex;
    align-items: center;

    &:disabled {
      opacity: 0;
      pointer-events: none;
    }

    &.label {
      cursor: default;
      font-weight: normal;
      color: $color-gray-bg;

      mark {
        background: transparent;
        color: $color-white;
        font-weight: bold;
        padding: rem(3);
      }
    }

    span {
      color: $color-green;
      font-size: rem(22);
      margin-left: 5px;
    }

    &.prev {
      span {
        margin-left: 0;
        margin-right: 5px;
      }
    }
  }
}
</style>
